export default "__VITE_ASSET__D399iuI8__"